module.exports = __webpack_public_path__ + "static/media/1_en.dc60a2ce.png";